// src
import * as actions from "actions/timeline";
import { updateView } from "actions/table";
import { HOUR, MINUTE } from "config/constants";
import { hydrateSlice } from "actions/system";
import { buildStorageAdapters } from "utils/storage";

const maxAge = 5 * MINUTE;
const saveDelay = 2000;
const [hydrate, save] = buildStorageAdapters("timeline", { maxAge, saveDelay });

const DEFAULT_STATE = {
  start: null,
  end: null,
};

export default (state = DEFAULT_STATE, { type, payload }) => {
  // order actions by frequency
  switch (type) {
    case actions.updateTimelineWindow.toString(): {
      const { start: newStart, end: newEnd } = payload;
      const { start, end } = state;

      // skip update
      const diffStart = Math.abs(start - newStart);
      const diffEnd = Math.abs(end - newEnd);
      if (diffStart < HOUR && diffEnd < HOUR) return state;

      return save({
        start: newStart,
        end: newEnd,
      });
    }
    case updateView.toString(): {
      const { view } = payload;
      return view === "timeline" ? state : DEFAULT_STATE;
    }
    case hydrateSlice.toString(): {
      return hydrate(state, payload);
    }
    default:
      return state;
  }
};
